import './NewsletterForm.scss';

import { b2x } from '@b2x/react/src';

import { Button } from '../Button';

// eslint-disable-next-line @typescript-eslint/ban-types
type AdditionalPropertiesFormValues = {};

// eslint-disable-next-line @typescript-eslint/ban-types
type AdditionalPropertiesValidationSchema = b2x.yup.ObjectSchema<{}>;

export type NewsletterFormProps = Omit<
  b2x.NewsletterFormProps<AdditionalPropertiesFormValues, AdditionalPropertiesValidationSchema>,
  | 'additionalPropertiesInitialValues'
  | 'additionalProperties'
  | 'additionalPropertiesValidationSchema'
  | 'validationSchemaSelector'
>;

export const NewsletterForm = ({ emailFieldStyle = 'textInput', ...otherProps }: NewsletterFormProps) => {
  return (
    <b2x.NewsletterFormHelper<AdditionalPropertiesFormValues, AdditionalPropertiesValidationSchema>
      {...otherProps}
      emailFieldStyle={emailFieldStyle}
      redirectToHomeOnSuccessModalClose
      validationSchemaSelector={{ name: false, surname: false }}
    >
      {({ fieldsHelper }) => (
        <>
          {emailFieldStyle === 'inputGroup' && (
            <b2x.FormGroup {...fieldsHelper.email.formGroup} className="custom-icon-btn-group" label={undefined}>
              <b2x.InputGroup {...fieldsHelper.email.inputGroup}>
                <b2x.TextInput {...fieldsHelper.email.textInput} />
                <Button
                  {...fieldsHelper.buttons.submit}
                  className="text-gray-400"
                  iconEnd={{ name: 'arrow-dx' }}
                  label={undefined}
                  size="small"
                  variant="blank"
                />
              </b2x.InputGroup>
            </b2x.FormGroup>
          )}
          {emailFieldStyle === 'textInput' && (
            <b2x.FormGroup {...fieldsHelper.email.formGroup} label={undefined}>
              <b2x.TextInput {...fieldsHelper.email.textInput} />
            </b2x.FormGroup>
          )}
          <fieldset>
            <legend className="d-none">{fieldsHelper.consents.legend}</legend>  
            <b2x.FormGroup {...fieldsHelper.consents.newsletterConsent.formGroup} label={undefined}>
              <b2x.Checkbox {...fieldsHelper.consents.newsletterConsent.checkbox} labelClassName="extra-small text-start" />
            </b2x.FormGroup>
          </fieldset>
          {emailFieldStyle === 'textInput' && (
            <div className="d-block">
              <b2x.Button {...fieldsHelper.buttons.submit} className="w-100" />
            </div>
          )}
        </>
      )}
    </b2x.NewsletterFormHelper>
  );
};
